import { renderSlot as _renderSlot, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue";
var _hoisted_1 = ["href"];
var _hoisted_2 = {
  class: "side-modal-button-icon"
};
var _hoisted_3 = {
  key: 0,
  class: "side-modal-button-text"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("a", {
    href: $props.link,
    class: "side-modal-button"
  }, [_createElementVNode("span", _hoisted_2, [_renderSlot(_ctx.$slots, "icon", {}, undefined, true)]), $props.text ? (_openBlock(), _createElementBlock("span", _hoisted_3, _toDisplayString($props.text), 1 /* TEXT */)) : _createCommentVNode("v-if", true)], 8 /* PROPS */, _hoisted_1);
}